module.exports = __webpack_public_path__ + "static/img/14-02.4df7f13.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/award/14-02.png
// module id = j+NU
// module chunks = 1